export const AI_DISCLOSURE_VERSION = 'ai-sharing-v1';
export const consentProvider = model => model === 'claude' ? 'anthropic' : model === 'gpt' ? 'openai' : null;
export const hasAiGrant = (record, provider) => Boolean(provider && record?.version === AI_DISCLOSURE_VERSION && record.grants?.some(grant => grant.provider === provider && grant.status === 'granted' && !grant.withdrawn_at));
